import { Injectable } from "@angular/core";
import { DateTime } from "luxon";
import { Adapter } from "src/app/core/adapter";
import { Model } from "src/app/core/models/model";
import { GraphElementDto } from "src/app/shared/components/graph/dto/graph-element-dto";

export class Shower implements Model, GraphElementDto {
  public get xLabel(): String {
    return this.shower_id.toString();
  }
  public get barValue(): number {
    return this.volume;
  }
  public get lineValue(): number {
    return this.temperature ? Math.round(this.temperature * 10) / 10 : null;
  }
  public line2Value: number = null;
  public bar2Value: number = null;
  public get barStyle(): string {
    if (this.is_live || this.is_real_date) {
      let diff = DateTime.local().diff(this.date, "minutes");
      if (diff.minutes <= 2) {
        return "flashing";
      } else if (this.is_live) {
        return "live";
      }
    } else if (!this.is_real_date) {
      return "no-real-date";
    }
    return "";
  }

  constructor(
    public shower_id: number,
    public device_uuid: string,
    public volume: number,
    public temperature: number,
    public flow: number,
    public duration: number,
    public soaping_time: number,
    public number_of_soapings: number,
    public date: DateTime,
    public is_real_date: boolean,
    public is_live: boolean
  ) {}

  public clone() {
    const clone = new Shower(
      this.shower_id,
      this.device_uuid,
      this.volume,
      this.temperature,
      this.flow,
      this.duration,
      this.soaping_time,
      this.number_of_soapings,
      this.date,
      this.is_real_date,
      this.is_live
    );

    clone.line2Value = this.line2Value;
    clone.bar2Value = this.bar2Value;

    return clone;
  }
}

@Injectable({
  providedIn: "root",
})
export class ShowerAdapter implements Adapter<Shower> {
  constructor() {}

  adapt(item: any): Shower {
    return new Shower(
      item.shower_id,
      item.device_uuid,
      item.volume,
      item.temperature,
      item.flow,
      item.duration,
      item.soaping_time,
      item.number_of_soapings,
      DateTime.fromISO(item.date),
      item.is_real_date,
      item.is_live
    );
  }
}
